var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Hr } from "@irati/ui/src/Layout";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import getWalletBalance from "@irati/wallet/apollo/query/WalletBalance";
import { WalletTypes } from "@irati/wallet/enums";
import { People as PeopleTransactions } from "../../../components/ReportingV2/Transactions";
import DataItem from "../../../components/ReportingV2/DataItem";
import BackToWallets from "../../../components/ReportingV2/BackToWallets";
import { BalanceContainer, StyledCard as Card } from "../styled";
var People = /** @class */ (function (_super) {
    __extends(People, _super);
    function People(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            balance: null
        };
        var variables = {
            currency: authentication.defaultUserCurrency(),
            walletType: WalletTypes.USER,
            tenantId: authentication.userTenant().uuid
        };
        getWalletBalance(variables).then(function (res) {
            _this.setState({ balance: res.getWalletBalanceAtTime.value });
        });
        return _this;
    }
    People.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var balance = this.state.balance;
        return (React.createElement("div", null,
            React.createElement(Card, null,
                React.createElement(BackToWallets, { title: formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.back" }) }),
                React.createElement(Hr, null),
                React.createElement(BalanceContainer, null,
                    React.createElement(DataItem, { currency: authentication.defaultUserCurrency(), dataItem: balance, large: true, bold: true, label: formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.balance.label" }), toolTipText: formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.balance.tooltip" }) }))),
            React.createElement(PeopleTransactions, null)));
    };
    return People;
}(Component));
export default injectIntl(People);
